import * as React from 'react';
import { styled } from '@glitz/react';
import {
  createCurrentPageWithErrorBoundary,
  createErrorBoundary,
  currentPageLoadFailure,
  ExciteSuspense,
  translate,
} from '@avensia/excite';
import { PageLoader } from 'webapp/components/page-loader';
import Header from 'webapp/shell/header';
import Footer from './shell/footer';
import 'webapp/html-decorators';
import { MainMenu } from './shell/main-menu';
import MiniCart from 'webapp/shell/mini-cart';
import { createThemeDecorator, Theme } from 'webapp/theme';
import { useEsalesNotifications } from '@avensia/excite-esales';
import { useTriggerbee } from 'webapp/use-triggerbee';
import { useFreshChat } from 'webapp/use-fresh-chat';
import { setAutoFreeze } from 'immer';
import { useEffect } from 'react';
import SiteWideBanner from 'webapp/site-wide-banner';
import { registerPriceFormatter } from '@avensia/excite-ui';
import { NOKFormatter } from 'webapp/price-formatters';
import SiteBanner from 'webapp/site-banner';
import { type AuthFlyoutType, useFlyoutView } from 'webapp/shell/flyout-context';
import { useTracking } from 'webapp/tracking';
import AriaLiveRegion from 'webapp/shared/aria-live-region';

registerPriceFormatter('NOK', NOKFormatter);

const AuthFlyout = React.lazy(() => import('webapp/authentication/AuthFlyout'));

export function SiteLayout() {
  useTracking();
  useEsalesNotifications();

  useTriggerbee();
  useFreshChat();
  useEffect(() => {
    setAutoFreeze(false);
  });
  const view = useFlyoutView();

  return (
    <React.StrictMode>
      <PageLoader black />
      <SiteBanner />
      <Top />
      <SiteWideBanner />
      <CurrentPageWithFallback />
      <Footer />
      <MiniCart />
      <ExciteSuspense
        loadComponent={view === 'Login' || view === 'Registration' || view === 'ResetPassword' || view === 'Success'}
      >
        <AuthFlyout view={view as AuthFlyoutType} />
      </ExciteSuspense>
        <AriaLiveRegion />
    </React.StrictMode>
  );
}

const Top = createErrorBoundary(() => (
  <>
    <Header />
    <MainMenu />
  </>
));

const CurrentPageWithFallback = createCurrentPageWithErrorBoundary(
  styled(
    () => {
      const loadFailure = currentPageLoadFailure.currentSync();
      const errorStatus = loadFailure?.response?.status;
      if (errorStatus && errorStatus >= 500 && errorStatus < 600) {
        return <styled.Div>{translate(t => t.internalServerError)}</styled.Div>;
      } else {
        return <styled.Div>{translate(t => t.unknownError)}</styled.Div>;
      }
    },
    createThemeDecorator(Theme.Negative),
    { padding: { xy: t => t.spacing.l }, textAlign: 'center' },
  ),
);
